var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ContentFrame, ScreenContainer } from '@pinwheel/origami';
import { useOpts } from '../../context';
import { useAppDispatch, useAppSelector } from '../../state';
import { clearSessionStatusResponse, initializeLogin, next, selectIsBackgroundIdentify, selectIsEligibleForAdp, selectIsInAccountRecovery, selectIsInManualInstructionsFallback, selectIsLoginDefaultStep, selectIsOnOrAfterLoginFormStep, selectJobType, selectLinkApiResponse, selectLoadedPlatform, selectPublicKey, setIsBackgroundIdentify, waitForJobStepResults, } from '../../state/slices/slice-link-api';
import { selectSelectedEmployer, selectSelectedPlatform, } from '../../state/slices/slice-provider-entity';
import LoadingView from '../../views/Loading';
import JobTemplate from '../../LinkApiRouter/views/JobTemplate';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import ModalHeader from '../../components/ModalHeader';
import useIsLinkApiLoading from '../../hooks/useIsLinkApiLoading';
import { setError } from '../../state/slices/slice-error';
import { tokenHasJob } from '../../utils';
import { generatePostLoginAttemptId, selectCurrentSource, updateEventSource, } from '../../state/slices/slice-segment';
import { EventSurface } from '../../types/events';
import eventQueue from '../../events/queue';
import { getLinkApiTemplateType, getLinkApiTemplateWithActions, } from '../../LinkApiRouter/utils/link-api-response';
import useFireClientEvent from '../../hooks/useFireClientEvent';
import { setDefaultAmountSelection } from '../../state/slices/slice-amount-selection';
import { selectExperiments, selectFeatureFlags, selectLinkParams, selectLinkTokenPayload, } from '../../state/slices/slice-link-params';
import JobTermsFooter from '../../LinkApiRouter/views/JobTermsFooter';
import isGuidedSwitch from '../../LinkApiRouter/utils/guided-switch';
import { incrementFailedLoginAttempts } from '../../state/slices/slice-document-uploads';
import LoginLoading from '../../views/LoginLoading';
import useAmountOrPercentageSupported from '../../views/AmountSelection/FullSwitchAndMore/hooks/useAmountOrPercentageSupported';
import { isAdp, isAdpPartnership } from '../../consts/platforms';
import AdpLoading from '../AdpIframe/AdpLoading';
import ReturnToSearchButton from '../../components/ReturnToSearchButton';
import { encryptInBrowser, shouldEncryptKey, } from '../../utils/public-key-encryption';
function getEventSurface(isAccountRecovery, isInManualInstructionsFallback, linkApiResponse, linkTokenPayload) {
    var isReauth = !!linkTokenPayload.accountId;
    var templateType = getLinkApiTemplateType(linkApiResponse);
    var templateWithActions = getLinkApiTemplateWithActions(linkApiResponse);
    if (isAccountRecovery) {
        return EventSurface.ACCOUNT_RECOVERY;
    }
    if (linkApiResponse.responseType === 'next_with_error') {
        if (isReauth) {
            return EventSurface.REAUTH_ERROR;
        }
        if (linkApiResponse.error.code === 'invalidCredentials') {
            return EventSurface.INVALID_CREDENTIALS_ERROR;
        }
    }
    if (templateType === 'provider_selection') {
        return EventSurface.PROVIDER_CONFIRMATION_BOUNDED;
    }
    if (templateType === 'search') {
        return EventSurface.PROVIDER_CONFIRMATION_UNBOUNDED;
    }
    if (templateType === 'continue' &&
        templateWithActions &&
        'actions' in templateWithActions) {
        return EventSurface.PROVIDER_CONFIRMATION_PRIMER;
    }
    if (templateType === 'manual_instructions' &&
        !isInManualInstructionsFallback) {
        return EventSurface.MANUAL_INSTRUCTIONS;
    }
    if (isReauth) {
        return EventSurface.REAUTH;
    }
    return EventSurface.LOGIN;
}
var getFieldKeysFromResponse = function (response) {
    if ('template' in response && 'fields' in response.template) {
        return response.template.fields.map(function (field) { return field.key; });
    }
    return [];
};
var Login = function () {
    var _a = useOpts(), linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId, exit = _a.exit;
    var dispatch = useAppDispatch();
    var navigate = useLinkNavigate();
    var linkParams = useSelector(selectLinkParams);
    var selectedPlatform = useSelector(selectSelectedPlatform);
    var selectedEmployer = useSelector(selectSelectedEmployer);
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var jobType = useSelector(selectJobType);
    var linkApiResponse = useSelector(selectLinkApiResponse);
    var isLoginDefaultStep = useSelector(selectIsLoginDefaultStep);
    var isAccountRecovery = useSelector(selectIsInAccountRecovery);
    var fireClientEvent = useFireClientEvent();
    var currentSource = useSelector(selectCurrentSource);
    var featureFlags = useSelector(selectFeatureFlags);
    var linkTokenPayload = useSelector(selectLinkTokenPayload);
    var experiments = useSelector(selectExperiments);
    var isLoginStep = useSelector(selectIsOnOrAfterLoginFormStep);
    var isInManualInstructionsFallback = useSelector(selectIsInManualInstructionsFallback);
    var amountOrPercentageSwitchSupported = useAmountOrPercentageSupported();
    var isEligibleForAdp = useSelector(selectIsEligibleForAdp);
    var doGuidedSwitch = useMemo(function () {
        return isGuidedSwitch(loadedPlatform, featureFlags);
    }, [loadedPlatform, featureFlags]);
    useEffect(function () {
        if (!linkApiResponse)
            return;
        // skip segment events if this is a guided switch, since user isn't really doing a login in that case
        if (doGuidedSwitch)
            return;
        // Handle impressions for the app clips flow separately, since we don't want
        // to fire an app clips impression if the `app_clip_skip` action is fired.
        if (getLinkApiTemplateType(linkApiResponse) === 'app_clip')
            return;
        var eventSurface = getEventSurface(isAccountRecovery, isInManualInstructionsFallback, linkApiResponse, linkTokenPayload);
        // Note, Login has special "routing" outside of react router.
        // Across different login screens, we don't want to change our previous source.
        // e.g. we want the first and second ACCOUNT_RECOVERY screens to both have last surface as LOGIN
        if (currentSource !== eventSurface)
            dispatch(updateEventSource(eventSurface));
        eventQueue.emit('impression', {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkApiResponse]);
    var isBackgroundIdentifyFlow = useAppSelector(selectIsBackgroundIdentify);
    useEffect(function () {
        var idObject = selectedEmployer
            ? { employerId: selectedEmployer.id }
            : selectedPlatform
                ? { platformId: selectedPlatform.id }
                : linkTokenPayload.platformId
                    ? { platformId: linkTokenPayload.platformId }
                    : linkTokenPayload.platformKey
                        ? { platformKey: linkTokenPayload.platformKey }
                        : { employerId: linkTokenPayload.employerId };
        if (!isBackgroundIdentifyFlow)
            void dispatch(initializeLogin({
                linkToken: linkToken,
                modalSessionId: modalSessionId,
                uniqueUserId: uniqueUserId,
                idObject: idObject,
                sdk: linkParams.sdk || '',
                sdkVersion: "".concat(linkParams.version.major, ".").concat(linkParams.version.minor, ".").concat(linkParams.version.patch),
            }));
        return function () {
            dispatch(clearSessionStatusResponse());
            dispatch(setIsBackgroundIdentify(false));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedEmployer, selectedPlatform]);
    useEffect(function () {
        void dispatch(setDefaultAmountSelection({
            linkParams: linkParams,
            loadedPlatform: loadedPlatform,
        }));
    }, [dispatch, linkParams, loadedPlatform]);
    useEffect(function () {
        var _a;
        if (jobType !== 'login')
            return;
        if (!linkApiResponse)
            return;
        if (linkApiResponse.responseType === 'next')
            return;
        if (linkApiResponse.responseType === 'processing') {
            void dispatch(waitForJobStepResults());
        }
        else if (linkApiResponse.responseType === 'success') {
            dispatch(generatePostLoginAttemptId());
            if (tokenHasJob(linkTokenPayload, 'direct_deposit_switch')) {
                if (((_a = linkApiResponse.maskedAccounts) === null || _a === void 0 ? void 0 : _a.length) > 1) {
                    navigate('/account-selection');
                }
                else if (isGuidedSwitch(loadedPlatform, featureFlags)) {
                    navigate('/link-api/guided-switch-primer');
                }
                else if (linkTokenPayload.skipDepositConfirmation) {
                    if (linkTokenPayload.enableUserInputBankInfo) {
                        navigate('/bank-info-input');
                    }
                    else {
                        navigate('/link-api/dds');
                    }
                }
                else if (linkTokenPayload.disableDirectDepositSplitting ||
                    !amountOrPercentageSwitchSupported) {
                    if (linkTokenPayload.enableUserInputBankInfo) {
                        navigate('/bank-info-input');
                    }
                    else {
                        navigate('/switch-confirmation');
                    }
                }
                else {
                    navigate('/amount-selection');
                }
            }
            else if (featureFlags.skipSuccessOrErrorTerminalScreen ||
                featureFlags.skipSuccessScreen) {
                exit();
            }
            else if (tokenHasJob(linkTokenPayload, 'bill_switch')) {
                navigate('/link-api/bill-switch');
            }
            else if (tokenHasJob(linkTokenPayload, 'bill_cancellation')) {
                navigate('/link-api/bill-cancellation');
            }
            else
                navigate('/success');
        }
        else if (linkApiResponse.responseType === 'pending_retry') {
            dispatch(setError({
                type: linkApiResponse.error.type,
                code: linkApiResponse.error.code,
                message: linkApiResponse.error.message,
                pendingRetry: true,
            }));
            if (featureFlags.skipSuccessOrErrorTerminalScreen) {
                exit();
            }
            else {
                navigate('/error');
            }
        }
        else if (linkApiResponse.responseType === 'error') {
            dispatch(setError({
                type: linkApiResponse.error.type,
                code: linkApiResponse.error.code,
                message: linkApiResponse.error.message,
                pendingRetry: false,
            }));
            if (featureFlags.skipSuccessOrErrorTerminalScreen) {
                exit();
            }
            else {
                navigate('/error');
            }
        }
        else if (linkApiResponse.responseType === 'next_with_error') {
            dispatch(setError({
                type: linkApiResponse.error.type,
                code: linkApiResponse.error.code,
                message: linkApiResponse.error.message,
                pendingRetry: false,
            }));
            // Used for Document Uploads entry point
            dispatch(incrementFailedLoginAttempts());
            if (featureFlags.skipSuccessOrErrorTerminalScreen &&
                !featureFlags.bypassSkipRetryableErrorScreen) {
                if (!experiments.skipFiringInvalidCredsErrorEvent) {
                    exit();
                }
            }
            // Temporary manual fallback for ADP login
            if (isInManualInstructionsFallback) {
                navigate('/link-api/manual-instructions-fallback');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkApiResponse, isInManualInstructionsFallback]);
    var isLoading = useIsLinkApiLoading();
    var willRouteToError = linkApiResponse &&
        (linkApiResponse.responseType === 'error' ||
            linkApiResponse.responseType === 'pending_retry');
    var shouldShowPlatformLogo = useMemo(function () {
        if (currentSource === EventSurface.PROVIDER_CONFIRMATION_BOUNDED ||
            currentSource === EventSurface.PROVIDER_CONFIRMATION_UNBOUNDED) {
            return false;
        }
        return true;
    }, [currentSource]);
    var loadingViewToShow = useMemo(function () {
        // Only show after the user has submitted a login form (i.e. don't show when
        // a provider is initially selected as the displayed loading text won't make
        // sense in context).
        return isLoginStep &&
            // First iteration/design of the dynamic loading screen experiment
            experiments.dynamicLoadingScreen === 'test1' ? (React.createElement(LoginLoading, null)) : isEligibleForAdp &&
            (isAdpPartnership(selectedPlatform === null || selectedPlatform === void 0 ? void 0 : selectedPlatform.id) ||
                isAdp(selectedPlatform === null || selectedPlatform === void 0 ? void 0 : selectedPlatform.id)) ? (React.createElement(AdpLoading, null)) : (React.createElement(LoadingView, null));
    }, [experiments, selectedPlatform, isLoginStep, isEligibleForAdp]);
    var publicKey = useSelector(selectPublicKey);
    return isLoading || willRouteToError ? (loadingViewToShow) : (React.createElement(ScreenContainer, { "data-testid": "linkApi/login" },
        React.createElement(ModalHeader, { showPlatformLogo: shouldShowPlatformLogo, hideBackButton: isBackgroundIdentifyFlow }),
        React.createElement(ContentFrame, null,
            React.createElement(JobTemplate, { linkApiResponse: linkApiResponse, submitStep: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
                    var fieldKeys, encryptedKeys, encryptionInfo, _i, _a, _b, key, value, encrypted;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                fieldKeys = getFieldKeysFromResponse(linkApiResponse);
                                if (fieldKeys.includes('password') ||
                                    fieldKeys.includes('mfa_code')) {
                                    fireClientEvent('other_event', {
                                        name: 'input_submit',
                                        payload: fieldKeys.map(function (fieldKey) { return ({
                                            key: 'input_type',
                                            type: 'string',
                                            value: fieldKey,
                                        }); }),
                                    });
                                }
                                if (isLoginDefaultStep) {
                                    fireClientEvent('login_attempt', {
                                        platformId: loadedPlatform.id,
                                    });
                                }
                                encryptedKeys = [];
                                encryptionInfo = null;
                                if (!publicKey) return [3 /*break*/, 5];
                                _i = 0, _a = Object.entries(payload);
                                _c.label = 1;
                            case 1:
                                if (!(_i < _a.length)) return [3 /*break*/, 4];
                                _b = _a[_i], key = _b[0], value = _b[1];
                                if (!(typeof value === 'string' && shouldEncryptKey(key))) return [3 /*break*/, 3];
                                return [4 /*yield*/, encryptInBrowser(publicKey.publicKey, value)];
                            case 2:
                                encrypted = _c.sent();
                                payload[key] = encrypted;
                                encryptedKeys.push(key);
                                _c.label = 3;
                            case 3:
                                _i++;
                                return [3 /*break*/, 1];
                            case 4:
                                encryptionInfo = {
                                    encryptedFields: encryptedKeys,
                                    keyPairId: publicKey.keyPairId,
                                };
                                _c.label = 5;
                            case 5: return [2 /*return*/, dispatch(next({ payload: payload, encryptionInfo: encryptionInfo }))];
                        }
                    });
                }); }, extraControlsTop: React.createElement(JobTermsFooter, null), extraControlsBottom: React.createElement(ReturnToSearchButton, null) }))));
};
export default Login;
